import { db } from './db';
import { новаяЭпоха } from './epoch';
import { сПовторомПриОбрыве } from './dbReconnect';

/** Стирание учебных данных устройства.
 *
 *  Зовётся при выходе из учётной записи — по решению владельца: приватность
 *  на общем планшете важнее сохранности неотправленного. Поэтому это
 *  разрушительное действие, и обращаться с ним надо соответственно: диалог,
 *  называющий число неотправленных тренировок, стоит ПЕРЕД вызовом.
 *
 *  Строка устройства переживает стирание. Идентификатор устройства и
 *  признак постоянного хранилища — не про ребёнка, и их потеря только
 *  заставила бы заново просить постоянное хранилище. Активный профиль при
 *  этом обнуляется: профилей больше нет.
 *
 *  Чего эта функция НЕ делает: не выходит из учётной записи и не трогает
 *  сервер. Стирание и выход — два разных действия, и сложение их в одно
 *  привело бы к тому, что истёкшая сессия (а `SIGNED_OUT` приходит и при
 *  неудачном обновлении токена) стирала бы данные ребёнка без диалога и без
 *  взрослого рядом. */
export async function wipeDevice(): Promise<void> {
  /** Эпоха поднимается ПЕРВОЙ, до транзакции стирания, и порядок несущий.
   *
   *  Обмен, ушедший в сеть до выхода, иначе переживает стирание: ответ
   *  сервера приходит позже и кладёт на чистое устройство детей и журналы
   *  прежней семьи, а экран после выхода здоров. Измерено исполнением
   *  (`tests/data/lifecycle.test.ts`). Обмен сверяет эпоху внутри каждой
   *  своей транзакции: открытая раньше этой кончится раньше чистки и будет
   *  вычищена, открытая позже увидит новую эпоху и не запишет ничего.
   *  Поднятая после чистки, эпоха оставила бы окно между ними открытым. */
  новаяЭпоха();
  /** Карантин и след непринятых стираются НАРАВНЕ с журналами, и это не
   *  педантизм: в строке карантина лежит `payload` — целая серверная строка
   *  журнала прежней семьи. Стирание при выходе существует ровно затем,
   *  чтобы следующий человек за общим планшетом не увидел чужого, и
   *  оставлять там куски чужого журнала значит не сделать этого. */
  const tables = [
    db.profiles, db.attempts, db.reveals, db.sessions, db.state, db.syncState, db.device,
    db.quarantine, db.notSent,
  ];
  /** `сПовторомПриОбрыве` — ПОСЛЕ `новаяЭпоха()` выше, не до: обёртка снимает
   *  свой снимок эпохи в момент ВЫЗОВА, и, встань она раньше подъёма, отказ
   *  соединения посреди самого первого прохода стирания читался бы как
   *  «эпоха сменилась между попытками» и гасил бы повтор — то есть ровно то
   *  стирание, ради которого эпоха и была поднята, само же осталось бы
   *  недоделанным. Повтор здесь безопасен: транзакция — `clear()` таблиц и
   *  идемпотентная перезапись строки устройства, повторить её дважды —
   *  то же самое, что один раз. */
  await сПовторомПриОбрыве(() => db.transaction('rw', tables, async () => {
    await Promise.all([
      db.profiles.clear(),
      db.attempts.clear(),
      db.reveals.clear(),
      db.sessions.clear(),
      db.state.clear(),
      db.syncState.clear(),
      db.quarantine.clear(),
      db.notSent.clear(),
    ]);
    const device = await db.device.get('singleton');
    if (device) await db.device.put({ ...device, activeProfileId: null });
  }));
}
